<!--
/*******************************************************************************
*@ 컴포넌트명   : MyAccountsDpostTab.vue
*@ 컴포넌트설명 : 전계좌조회 - 예적금 
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <template v-if="dpostAcn">
      <account-box-header v-show="openDetail" :summary="brifDpostAcn" />
      <account-box :acn-list="dpostAcn" :page="`myAccount`" />
    </template>
    <template v-else>
      <!-- 조회결과가 없음 -->
      <div class="empty">
        <div class="empty-img">
          <i class="icon icon-opt-no" />
        </div>
        <strong class="empty-text">{{ /*조회 내역이 없습니다.*/ $t("MCOM-0000015") }}</strong>
      </div>
    </template>
  </article>
</template>

<script>
import { mapGetters } from "vuex";
import AccountBoxHeader from "@/components/page/accounts/AccountBoxHeader";
import AccountBox from "@/components/page/accounts/AccountBox";
export default {
  name: "MyAccountsDpostTab",
  props: {
    openDetail: {
      type: Boolean,
      required: true,
    },
    showDetail: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    AccountBoxHeader,
    AccountBox,
  },
  mounted() {
    if (this.brifDpostAcn) {
      this.showDetailData = true;
    } else {
      this.showDetailData = false;
    }
  },
  computed: {
    ...mapGetters("accounts/myAccounts", ["getDpostAccountBox"]),
    brifDpostAcn() {
      if (this.getDpostAccountBox) {
        return this.getDpostAccountBox.summary;
      } else {
        return [];
      }
    },
    dpostAcn() {
      if (this.getDpostAccountBox) {
        return this.getDpostAccountBox.data;
      } else {
        return [];
      }
    },
    showDetailData: {
      get() {
        return this.showDetail;
      },
      set(value) {
        this.$emit("update:showDetail", value);
      },
    },
  },
  methods: {},
};
</script>